module.exports = __webpack_public_path__ + "img/furongwang.9f52285d.jpg";